import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { FormData, ISection, Step, SubSection } from '../../pages/project-management/risk-assessment-sections/roadmap-interface';
import { GraphService } from 'src/app/services/graph/graph.service';
import { addUniqueEntry, isNotEmptyArray } from 'src/app/utilities/utils';
import { filter, take } from 'rxjs/operators';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';
@Component({
  selector: 'app-riskassessment-accordion',
  templateUrl: './riskassessment-accordion.component.html',
  styleUrls: ['./riskassessment-accordion.component.scss'],
})
export class RiskassessmentAccordionComponent implements OnInit {
  @Input() sectionName: string;
  @Input() roadmapStatus: string;
  @Input() subSectionName: string;
  @Input() subSectionSteps: any = [];
  @Input() isCustom: string;
  @Input() roadMapName: string;
  @Input() subSectionIndex: number;
  @Input() isRiskReassessment: boolean;
  @Input() roadmapsCompleteData: ISection[];
  @Input() roadMapId: string;
  @ViewChild('questionTextArea') questionTextArea: any;
  @Output() provideComplianceType: EventEmitter<any> = new EventEmitter();
  isListItemOpened = false;
  files = [];
  imageSrc: any;
  queryParams: any={};
  // stepName: any;
  selectedLanguage: string = this.serviceMulti.getDefaultLanguage();

  hazardRatingList = [
    { listName: 'Probability of Occurence', listNameView: this.selectedLanguage == 'en' ? 'Likelihood Of Occurences(LO)' : 'Eintrittswahrscheinlichkeit (LO)', val: 'PO', weightagesList: this.sharedValue.weightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Frequency of Exposition', listNameView: this.selectedLanguage == 'en' ? 'Frequency Of Exposure(FE)' : 'Häufigkeit der Gefährdung(FE)', val: 'FE', weightagesList: this.sharedValue.FEweightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Degree of Severity', listNameView: this.selectedLanguage == 'en' ? 'Degree Of Possible Harm(DPH)' : 'Schweregrad der Verletzung (DPH)', val: 'SD', weightagesList: this.sharedValue.DPEweightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Number of Persons Exposed', listNameView: this.selectedLanguage == 'en' ? 'Number of Persons at Risk(NPE)' : 'Anzahl der gefährdeten Personen (NPE)', val: 'NP', weightagesList: this.sharedValue.NPEweightagesList, dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '' }];

  currantHrnRatingValue = [];
  hazardCheckLists: any;

  constructor(private route: ActivatedRoute,
    private toastService: ToastService,
    private translate: TranslateService,
    private serviceMulti: LanguageSupportService, 
    public backendService: BackendCallService, private router: Router, private domSanitizer: DomSanitizer, private sharedValue: ShareValuesService, private graphService: GraphService) {
    this.route.queryParams.subscribe(async (params) => {
      this.queryParams=params;
    });
  }

  checkComplianceType(complianceType) {
    this.provideComplianceType.emit(complianceType);
  }

  ngOnInit() {
    this.sharedValue.applyHazardRatingLanguage(this.hazardRatingList, this.selectedLanguage);
  }

  toggleAccordion(step, index, list): void {
    this.questionTextArea.setFocus();
    list[index - 1] ? list[index - 1].isListItemOpened = false : '';
    list[index + 1] ? list[index + 1].isListItemOpened = false : '';
    step.isListItemOpened = !step.isListItemOpened;
  }

  toggleHazard(step): void {
    step.isHazardOpened = !step.isHazardOpened;
  }

  deleteStep(deleteStep, i) {
    // this.subSectionSteps.splice(i, 1);
    if (!this.isRiskReassessment && this.roadmapStatus != 'Completed') {
      if (deleteStep.id) {
        this.roadmapsCompleteData.forEach((eachSection: ISection) => {
          const subSections = eachSection.subSections;
          subSections.forEach((eachSubSection: SubSection) => {
            eachSubSection.steps.forEach((step: Step) => {
              if (deleteStep.id == step.id) {
                const payload = {
                  id: this.roadMapId,
                  serviceMachineId: this.queryParams.serviceMachineId,
                  projectId: this.queryParams.project_id,
                  section: [
                    {
                      sectionId: eachSection.sectionId,
                      isDelete: false,
                      subSection: [
                        {
                          subSection_Id: eachSubSection.subSection_Id,
                          isDelete: false,
                          steps: [
                            {
                              id: step.id,
                              isDelete: true
                            }
                          ]
                        }
                      ]
                    }
                  ]
                };
                this.backendService.deleteRoadmapSectionsData(payload).subscribe(
                  (data: any) => {
                    this.subSectionSteps.splice(i, 1);
                    this.provideComplianceType.emit('step');                    
                    this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                  },
                  (err) => {
                  }
                );
              }
            });
            // }
          });
        });
      } else {
        this.subSectionSteps.splice(i, 1);
        // if(subSectionSteps==[]){
        this.provideComplianceType.emit('step');
        // }
      }
    }
  }


  editHazard(eachHazard, step) {
    this.backendService.getFourEyeQualityHazardCheckListsInfo(eachHazard.id).then((res: any) => {
      if (res) {
        this.hazardCheckLists = res;
        this.constructHazardHrnStructure(eachHazard, step);
      }
    }).catch(err => {
      console.log('getting issue in fetching four eye quality hazard cheklist info :', err);
    });

  }

  goToHazrdsPage(eachHazard, step) {
    step.hazardTypesData = [];
    const sectionInfo = {
      sectionName: this.sectionName,
      subSectionName: this.subSectionName,
      index: 0,
      roadMapName: this.roadMapName
    };
    const hazrdInfo = {
      id: eachHazard.id,
      stepBody: '',
      stepNote: '',
      answers: null,
      hazardCount: 0,
      isListItemOpened: true,
      compliance: 'hazard',
      hazardName: this.hazardCheckLists?.name,
      hazardType: this.hazardCheckLists?.hazardType,
      hazardRatingList: this.hazardRatingList,
      machineModes: this.hazardCheckLists?.machineModes,
      machineModesWithIds: this.hazardCheckLists?.machineModesWithIds,
      riskmachineModes: this.hazardCheckLists?.riskmachineModes,
      riskMachineModesWithIds: this.hazardCheckLists?.riskMachineModesWithIds,
      pickInitialHazard: this.hazardCheckLists?.initial_hazard,
      pickInitialHazardValue: this.hazardCheckLists?.initial_hazard,
      pickControlMeasure: this.hazardCheckLists?.counter_measure,
      pickCntrlMeasureValue: this.hazardCheckLists?.counter_measure,
      determinePlrValue: this.hazardCheckLists?.plr,
      recommendedCategory: this.hazardCheckLists?.category,
      hazardImagesList: this.hazardCheckLists?.hazardMedia,
      plrObj: this.hazardCheckLists.plrObj
    };
    this.hazardCheckLists.hazardType.forEach(_ht => {
      const sourceBody = [];
      const consequeceBody = [];
      _ht.hazardSources.forEach(_hts => { sourceBody.push(_hts.source); });
      _ht.hazardConsequences.forEach(_hts => { consequeceBody.push(_hts.consequences); });
      step.hazardTypesData.push({ hazardType: _ht.hazardTypeName || _ht.type, source: sourceBody, consequences: consequeceBody });
    });
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'merge',
    };
    const hazardInfo = {
      isEditingFourEyeQuality: true,
      sectionData: sectionInfo,
      isCustom:this.isCustom,
      hazardData: hazrdInfo,
      roadmapStatus: this.roadmapStatus,
      isRiskReassessment: this.isRiskReassessment,
      addNewHazard: false
    };
    // Store the parameter in sessionStorage
    sessionStorage.setItem('hazardInfo', JSON.stringify(hazardInfo));
    this.router.navigate([window.location.pathname, 'add-hazard-details'],navigationExtras);
  }

  async constructHazardHrnStructure(eachHazard, step) {
    if (isNotEmptyArray(this.hazardCheckLists.hrnCalculations)) {
      const machineModes = [];
      const machineModesWithIds = [];
      const riskmachineModes = [];
      const riskMachineModesWithIds = [];
      this.hazardCheckLists?.hrnCalculations.forEach(_hrn => {
        if (_hrn.type == 'Current') {
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(machineModes, _val.mode));}
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(machineModesWithIds, { mode: _val.mode, id: _val.id, type: _hrn.type }));}
        }
        if (_hrn.type == 'Risk Reassessment Current') {
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(riskmachineModes, _val.mode));}
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(riskMachineModesWithIds, { mode: _val.mode, id: _val.id, type: _hrn.type }));}
        }
      });
      this.hazardCheckLists.hrnCalculations.forEach(_hrn => {
        if (_hrn.type == 'Current' || _hrn.type == 'current') {
          this.hazardRatingList.forEach(_hr => {
            machineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };
                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }


                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po;
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataChrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Indicative' || _hrn.type == 'indicative') {
          this.hazardRatingList.forEach(_hr => {
            machineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataIhrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Risk Reassessment Current') {
          this.hazardRatingList.forEach(_hr => {
            riskmachineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataRiskChrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Risk Reassessment Indicative') {
          this.hazardRatingList.forEach(_hr => {
            riskmachineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataRiskIhrn[_mode] = body;
                }
              });
            });
          });
        }
      });
      this.hazardCheckLists.machineModes = machineModes;
      this.hazardCheckLists.machineModesWithIds = machineModesWithIds;
      this.hazardCheckLists.riskmachineModes = riskmachineModes;
      this.hazardCheckLists.riskMachineModesWithIds = riskMachineModesWithIds;
      await this.goToHazrdsPage(eachHazard, step);
    } else {
      this.hazardCheckLists.machineModes = [];
      this.hazardCheckLists.machineModesWithIds = [];
      this.hazardCheckLists.riskmachineModes = [];
      this.hazardCheckLists.riskMachineModesWithIds = [];
      await this.goToHazrdsPage(eachHazard, step);
    }
  }

  addHazardDetails(index, step) {
    if (step.stepBody) {
      const data = { sectionName: this.sectionName, subSectionName: this.subSectionName, index, roadMapName: this.roadMapName, question: step.stepBody };
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'merge',
        // state: {
        //   sectionData: data,
        //   hazardData: step,
        //   roadmapStatus: this.roadmapStatus,
        //   isRiskReassessment: this.isRiskReassessment,
        //   addNewHazard: true
        // },
      };
      const hazardInfo = {
        sectionData: data,
        hazardData: step,
        isCustom:this.isCustom,
        roadmapStatus: this.roadmapStatus,
        isRiskReassessment: this.isRiskReassessment,
        addNewHazard: true,
        serviceMachineId:this.queryParams.serviceMachineId
      };
      // Store the parameter in sessionStorage
      sessionStorage.setItem('hazardInfo', JSON.stringify(hazardInfo));
      this.router.navigate([window.location.pathname, 'add-hazard-details'],navigationExtras);
    } else {
      this.toastService.presentToast(this.translate.instant('please_complete_all_mandatory_fields'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }

  }
  markAsComplete(step) {
    step.isListItemOpened = !step.isListItemOpened;
  }

  deleteImage(eachImg, eachImgArry: [], i) {
    if (eachImg.id) {
      const payload = {
        id: eachImg.id,
        fileName: eachImg.fileName,
        contentType: '',
        url: eachImg.url,
        driveId: eachImg.driveId,
        itemId: eachImg.itemId,
        isType: 'complaint',
      };
      this.backendService.deleteMediaFile(payload).subscribe((res: any) => {
        eachImgArry.forEach((element: any) => {
          if (element.fileName == eachImg.fileName) {eachImgArry.splice(i, 1);}
        });
        this.graphService.deleteItem(eachImg.driveId, eachImg.itemId).subscribe(res => {
        });
      });
    } else {
      eachImgArry.splice(i, 1);
    }
  }

  uploadFile(fileChangeEvent, step, index: number, complaintImage: HTMLInputElement) {
    const self = this;
    if (fileChangeEvent.target.files && fileChangeEvent.target.files[0]) {
      const file = fileChangeEvent.target.files[0];
      const reader = new FileReader();
      reader.onload = e => {
        self.imageSrc = reader.result;
        // self.files.push(self.imageSrc);
        step.previewImages = step.previewImages || [];
        step.previewImages.push({ img: self.imageSrc, name: fileChangeEvent.target.files[0]?.name });
      };
      reader.readAsDataURL(file);
    }
    const file = fileChangeEvent.target.files[0];
    const fileName = fileChangeEvent.target.files[0].name;
    const fileType = fileName.match(/\.[0-9a-z]+$/i);

    const fileSize = fileChangeEvent.target.files[0].size;
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const folderPath = 'General/Machines/' + this.queryParams.selectedMachineName;
      const UploadImageFolderPath = 'Pictures';
      await this.checkFolderExists(folderPath, UploadImageFolderPath);
      await this.UploadFileToSharePoint(folderPath + '/' + UploadImageFolderPath, fileName, file, fileSize, fileType, step);
    };
    reader.onerror = (error) => {
    };
    complaintImage.value = '';
  }


  async checkFolderExists(folderPath, name) {
    this.graphService.getFolderDetails(folderPath).subscribe((res: any) => {
      if (res) {
        if (res.value.filter(function(e) { return e.name === name; }).length == 0) {
          const folderPathDetails = 'General/Machines/' + this.queryParams.selectedMachineName;
          this.createFolder(folderPathDetails, name);
        }
      }
    });
  }

  async UploadFileToSharePoint(folderPath, fileName, file, fileSize, fileType, step) {
    if (fileSize < 4194304) {
      this.graphService.UploadFile(fileName, file, folderPath).subscribe((res: any) => {
        if (res) {
          const imageData = {
            fileName: res.name,
            contentType: res.file.mimeType,
            url: res.webUrl,
            driveId: res.parentReference.driveId,
            itemId: res.id,
            image_Size: fileSize
          };
          if (step.complaintMedia == null) {step.complaintMedia = [];}
          step.complaintMedia.push(imageData);
        }
      }, err => {
      });
    } else if (fileSize < 94371840) {
      this.graphService.createUploadSession(fileName, fileSize, folderPath).subscribe((res: any) => {
        if (res.uploadUrl) {
          this.sharedValue.uploadChunks(file, res.uploadUrl).then((res: any) => {
            if (res[1]) {
              const imageData = {
                fileName: res[1].name,
                contentType: res[1].file.mimeType,
                url: res[1].webUrl,
                driveId: res[1].parentReference.driveId,
                itemId: res[1].id,
                image_Size: fileSize
              };
              if (step.complaintMedia == null) {step.complaintMedia = [];}
              step.complaintMedia.push(imageData);
            }
          });
        } else if (res.error) {
          this.toastService.presentToast(res.error.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      }, err => {
      });
    } 
  }

  async createFolder(folderPath, name) {
    const folderCreatePayload = {
      name,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename'
    };
    this.graphService.createFolder(folderCreatePayload, folderPath).subscribe((res) => {
    });
  }




}
